import rest from './rest';
import store from '@/store';


async function login(email, password) {
  const response = await rest.post('/login', { email, password });
  if (response.tokens) {
    store.set('mfa', response);
    return response;
  }
  store.set('authenticated', true);
  return null;
}

async function logout() {
  await rest.post('/logout');
  store.commit('reset');
}

async function forgot(email) {
  await rest.post('/forgot-password', {email: email});
}

async function confirm(username, code, password) {
  await rest.post('/confirm-forgot-password', {
    username,
    code,
    password
  });
}

async function mfa(username, tokens, code) {
  await rest.post('/mfa', { username, tokens, code });
  store.set('authenticated', true);
  store.set('mfa', {});
}

async function signup(email, password) {
  const user = await rest.post('/signup', {email, password});
  store.set('user', user);
}

async function authenticated() {
  const response = await rest.get('/authenticated');
  store.set('authenticated', response.authenticated);
  return response.authenticated;
}


export default {
  login,
  logout,
  forgot,
  confirm,
  mfa,
  signup,
  authenticated,
};
